































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import gameOneIcon from '@/assets/game1.png'
import gameTwoIcon from '@/assets/game2.png'
import gameThreeIcon from '@/assets/game3.png'

@Component
export default class GamblingHome extends Vue {
  @Prop({ type: Boolean, required: false }) isAuthenticated!: boolean
  @Prop({ type: Function, required: false }) setLogInModal!: void
  @Prop({ type: Function, required: false }) makeDeposit!: void
  @Prop({ type: String, required: false }) currencyCode!: string
  @Prop({ type: String, required: false }) choosedTheme!: string
  @Prop({ type: String, required: false }) fullName!: string

  private cards: object[] = [
    { src: gameOneIcon },
    { src: gameTwoIcon },
    { src: gameThreeIcon }
  ]

  get iconBg () {
    const theme = document.querySelector('#gambling-theme-vars')
    const iconBg = theme && theme.innerHTML.includes('--icon-bg')
    if (iconBg) {
      return 'icon-bg'
    } else {
      return 'highlight-text-color'
    }
  }
  get iconBgLine () {
    const style = getComputedStyle(document.body)
    const iconBg = style.getPropertyValue('--icon-bg')
    const bgText = style.getPropertyValue('--color')
    if (this.iconBg === 'icon-bg') {
      return iconBg
    }
    return bgText
  }
}
